import { NameDto } from '../../Common/Types'
import { CurrencyType } from '../../Wallet/Types/Wallet'

export interface ClientBankAccount {
  id: string
  client: NameDto
  bankDetails: {
    id: string
    name: string
    code: string
    address: string
    status: NameDto
  }
  bankName: string
  bankCode: string
  bankCodeSort: string
  bankAddress: string
  bankAccount: string
  accountName: string
  currency: NameDto<CurrencyType>
  comment: string
  status: NameDto
  document: NameDto<string>
}

export interface AddClientBankAccount {
  clientId: string
  bankName: string
  bankCode: string
  bankAddress: string
  accountName: string
  codeSort: string
  bankAccount: string
  comment: string
  documentId?: string
}
export interface UpdateClientBankAccount extends AddClientBankAccount {
  id: string
  statusId: number
}

export enum ClientBankAccountStatus {
  PENDING = 10,
  APPROVED = 20,
  REJECTED = 30,
  EXPIRED = 40,
}
